import React from 'react';
import { Box, LinearProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CRM_COLORS } from '../../theme/crmColors';

const useStyles = makeStyles(() => ({
    viewport: {
        width: '100%',
        position: 'relative',
        backgroundColor: CRM_COLORS.background,
        borderRadius: 8,
        overflow: 'hidden',
    },
    iframe: {
        border: 0,
        width: '100%',
        height: '100%',
        display: 'block',
    },
    centered: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
}));

interface MetabaseIframeProps {
    url: string | null;
    loading: boolean;
    error: string | null;
    /** Título accesible del iframe. Sin él, un lector de pantalla anuncia solo «frame». */
    title: string;
    height?: number;
}

const MetabaseIframe: React.FC<MetabaseIframeProps> = ({ url, loading, error, title, height = 350 }) => {
    const classes = useStyles();

    return (
        <Box className={classes.viewport} style={{ height }}>
            {loading && <LinearProgress />}

            {!loading && error && (
                <Box className={classes.centered}>
                    <Typography color='error' variant='body2'>
                        {error}
                    </Typography>
                </Box>
            )}

            {!loading && !error && url && <iframe src={url} title={title} className={classes.iframe} />}
        </Box>
    );
};

export default MetabaseIframe;
